<template>
  <div class="user-dispatcher">
    <svg-icon :svg-content="dispatcherIcon" size="32" color="#fff" hover-color="#fff" />
    <md-select v-model="roleValue" popper-class="user-dispatcher-popper" @change="handleSelect">
      <p class="md-select-title"><span class="option-item">账号</span><span class="option-item">角色</span></p>
      <md-option v-for="item in roleData" :key="item.value" :label="item.label" :value="item.value">
        <span class="option-item">{{ item.userCode }}</span>
        <span class="option-item">{{ item.label }}</span>
      </md-option>
    </md-select>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { MdMessage } from 'mdesign3';
import SvgIcon from '@/components/SvgIcon';
import dispatcherIcon from '@/assets/dispatcher.svg?raw';
import { switchAccount } from '@/api/userApi';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { storageResource } from '@/views/login/components/utilsLogin';
import { genrateModRouterMap } from '@/utils/route.module.ts';
const store = useStore();
const router = useRouter();
const curUserCode = store.state.user?.userCode;
let roleList = store.state.roleList;
const curRole = store.state.curRole;
const roleValue = ref(curRole + ',' + curUserCode);

// 过滤掉v3试点角色处理
if (import.meta.env.MODE === 'production') {
  roleList = roleList.filter((role: any) => role.roleCode !== 'RL202512250538')
}
const roleData = roleList.map((item) => {
  return {
    value: item.roleCode + ',' + item.userCode,
    label: item.roleName,
    userCode: item.userCode,
    roleCode: item.roleCode,
    roleGroupCode: item.roleGroupCode,
  };
});

const changeRoleResources = () => {
  store.dispatch('initSystem').then((res) => {
    if (res.authority && res.authority.length > 0) {
      store.dispatch('delAllViews');

      const routerMap = genrateModRouterMap(store.getters.authority);
      const homePath = routerMap.find((item: string) => {
        return item.indexOf('/index') > -1 && item.endsWith('/index');
      });
      if (homePath && homePath.split('/').filter((item: string) => item)[1] === 'index') {
        router.push(homePath);
      }
    }
  });
};

const handleSelect = async (value: string) => {
  const curUserCode = store.state.user?.userCode;
  const userCode = roleData.find((item) => item.value === value)?.userCode;
  const roleCode = roleData.find((item) => item.value === value)?.roleCode;

  if (userCode === curUserCode) {
    localStorage.setItem('CUR_ROLE', roleCode);
    // changeRoleResources();
    // window.location.reload();// 刷新页面
    window.location.replace('/');// 切换到首页
  } else {
    try {
      const res = await switchAccount({ targetUserCode: userCode });
      if (res.code === '0') {
        const userInfo = res?.data;
        storageResource({ roleCode, roleList, userInfo, currentTenant: userInfo.currentTenant });
        // changeRoleResources();
        // window.location.reload();// 刷新页面
        window.location.replace('/');// 切换到首页
      }
    } catch (error) {
      MdMessage.error(error?.message || '切换账号失败');
    }
  }
};
</script>

<style lang="less" scoped>
.user-dispatcher {
  position: relative;
  &:after {
    content: '';
    position: absolute;
    width: 1px;
    height: 16px;
    right: -4px;
    background: #f2f3f5;
  }
  ::v-deep .md-select {
    position: relative;
    width: 82px;
    .select-trigger.md-tooltip__trigger {
      margin-left: 0;
      .md-input__inner {
        border: none;
      }
    }
    .md-input.md-input--suffix .md-input__inner {
      padding-right: 31px;
    }
  }

  display: flex;
  height: 50px;
  align-items: center;
  .md-dropdown {
    line-height: 24px;
  }
  ::v-deep .md-tooltip__trigger {
    display: flex;
    align-items: center;
    margin-left: 8px;
    color: #4e5969;
    cursor: pointer;

    .md-input__inner,
    .md-input .md-select__caret {
      color: #4e5969;
      &:hover {
        color: #1d2129;
      }
    }

    .md-input {
      &:hover {
        .md-select__caret {
          color: #1d2129;
        }
      }
    }
  }
}

.user-dispatcher-popper {
  .md-select-dropdown__item,
  .md-select-title {
    // width: 200px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    margin: 0;
    line-height: 32px;
    color: #272e3b;
    gap: 12px;
    .option-item {
      width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .user-solid {
      display: none;
    }
    &.selected {
      color: var(--md-color-primary);
      background-color: #e5f0fe;
      .user-solid {
        display: inline-block;
      }
    }
    &:hover {
      background-color: #f2f3f5;
    }
  }
}
</style>
